// extracted by mini-css-extract-plugin
export default {"component":"EditOfficeDetailsModal_component__9z87K","modalContainer":"EditOfficeDetailsModal_modalContainer__lq+Uc"};